<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" @close="qx()" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form  v-loading="myLoading" :model="dataForm" :rules="dataRule"  ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '150px' : '150px'">
      <div class="loan_title">
        <h3>借款人</h3>
        <el-select class="sel" disabled @change="selectLoanType()" v-model="dataForm.borrowerType"  placeholder="请选择">
          <el-option
            v-for="item in loanTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div v-if="dataForm.borrowerType == 'PERSONAGE'">
        <el-form-item label="身份证" prop="idPicture" >
        <div class="tip_upload">
          <div>
          <div class="id-upload">
          <el-upload
            drag
            :action="uploadUrl"
            :on-success="handleSuccessFront"
            :on-error="handleErrorFront"
            :on-remove="handleRemoveFront"
            :on-preview="handlePreviewFront"
            :before-upload="beforeUploadFront"
          >
            <img v-if="frontUrl" :src="frontUrl" class="avatar">
            <div v-else class="id-card">
              <div>
                <div class="title">头像面</div>
                <div>
                  <img src="../../../assets/img/头像面.png" alt="">
                </div>
              </div>
              <div>
                  <div class="add">+</div>
                  <div>请上传身份证头像面图片</div>
                </div>
            </div>
          </el-upload>
          <!-- <i class="el-icon-delete deleteIcon"></i> -->
        </div>
        <div class="id-upload">
          <el-upload
            drag
            :action="uploadUrl"
            :on-success="handleSuccessBack"
            :on-remove="handleRemoveBack"
            :on-preview="handlePreviewBack"
            :before-upload="beforeUploadBack"
          >
            <img v-if="backUrl" :src="backUrl" class="avatar">
            <div v-else class="id-card">
              <div>
                <div class="title">国徽面</div>
                <div>
                  <img src="../../../assets/img/国徽面.png" alt="">
                </div>
              </div>
              <div>
                  <div class="add">+</div>
                  <div>请上传身份证国徽面图片</div>
                </div>
            </div>
          </el-upload>
          <!-- <i class="el-icon-delete deleteIcon"></i> -->
        </div>
        <div style="display: flex; align-items: center;">
          <el-button type="primary"  @click="idUpload">{{!dataForm.id ? '确认上传' : '确认修改'}}</el-button>
          <div v-if="dataForm.id && !dataForm.validityPeriod" style="display: flex; align-items: center;margin-left: 20px;">
            <img style="width: 16px;" src="../../../assets/img/warning_red.svg" alt="">
            <div style="color:  #d9001b;margin-left: 10px;">点击“确认修改”获取证件有效期</div>
          </div>
        </div>
        
        </div>
        <div class="tips">
          1.请确保借款人身份证图片所有信息清晰可见，内容真实有效，无任何修改<br>
          2.文件大小不超过3M，格式支持 ：jpg，jpeg，png，bmp <br>
          3.图片建议分辨率为1024*768
        </div>
        </div>
      </el-form-item>
      <div class="line-box">
      
      <el-form-item label="姓名" prop="custName" class="styW">
          <el-input @change="verification" v-model="dataForm.custName" disabled placeholder="上传身份证后自动识别"></el-input>
      </el-form-item>
     
      <el-form-item label="证件号码" prop="idNo" class="styW">
          <el-input v-model="dataForm.idNo" disabled placeholder="上传身份证后自动识别" ></el-input>
      </el-form-item>
      <el-form-item label="证件有效期" prop="validityPeriod" class="styW">
          <el-input v-model="dataForm.validityPeriod" disabled placeholder="上传身份证后自动识别" ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="mobile" class="styW">
          <el-input v-model="dataForm.mobile" placeholder="手机号"></el-input>
      </el-form-item>
      <!-- <el-form-item label="学历" prop="educationCode" class="styW">
        <el-select class="sandh" v-model="dataForm.educationCode" clearable placeholder="请选择">
          <el-option
            v-for="item in xl"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      
      <!-- <el-form-item label="婚姻状态" prop="isMarriedCode" class="styW">
        <el-select class="sandh" v-model="dataForm.isMarriedCode" clearable placeholder="请选择">
          <el-option
            v-for="item in hy"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item  label="子女" prop="children" class="styW">
        <el-input-number class="sandh" v-model="dataForm.children" :min="0" :max="10" label="描述文字"></el-input-number>
      </el-form-item> -->

         <el-form-item label="职业" prop="companyType"  class="styW">
            <el-select class="sandh" v-model="dataForm.companyType" clearable placeholder="请选择">
              <el-option
                v-for="item in zy"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="邮箱地址" prop="email"  class="styW1">
          <el-input v-model="dataForm.email" placeholder="请输入"></el-input>
        </el-form-item>
        </div>
         <el-form-item label="现住地址" prop="address"  class="sandh">
            <el-input v-model="dataForm.address" placeholder="请输入"></el-input>
          </el-form-item>
      </div>
      <div v-if="dataForm.borrowerType == 'ENTERPRISE'"> 
        <el-form-item label="企业名称" prop="custName" class="styW">
          <el-input @change="verification()" @input="inputName" v-model="dataForm.custName" placeholder="企业名称"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="idNo" class="styW">
          <el-input @change="verification()" @input="inputCode" v-model="dataForm.idNo" placeholder="统一社会信用代码"></el-input>
        </el-form-item>
        <el-form-item label="企业法定代表人姓名" prop="repName" class="styW">
          <el-input @change="verification()" v-model="dataForm.repName" placeholder="企业法定代表人姓名"></el-input>
        </el-form-item>
        <el-form-item label="通讯地址" prop="address" class="styW">
          <el-input v-model="dataForm.address" placeholder="通讯地址"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="mobile" style="min-width: 500px;">
          <div style="display: flex;">
            <el-input style="width: 250px;" v-model="dataForm.mobile" placeholder="联系电话"></el-input>
            <div class="tip" >
            <img src="../../../assets/img/waring.svg" alt="">
            <span>用于接收短信（签署借款合同），请保证其真实有效。</span>
          </div>
          </div>
        </el-form-item>
        <el-form-item label="电子邮箱" prop="email" class="styW">
          <el-input v-model="dataForm.email" placeholder="电子邮箱"></el-input>
        </el-form-item>
      </div>
      <div class="loan_title">
        <h3>收款人</h3>
        <el-select class="sel" disabled v-model="dataForm.payeeType" placeholder="请选择">
          <el-option
            v-for="item in collectList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div v-if="dataForm.payeeType == 'PERSONAGE'">
        <el-form-item label="收款银行卡号" prop="bankCardNo" class="styW">
          <el-input type="number" v-model="dataForm.bankCardNo" placeholder="银行卡号"></el-input>
        </el-form-item>
        <el-form-item class="styW" label="银行名称" prop="bankName" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          <el-select class="sandh" v-model="dataForm.bankName"  filterable  clearable placeholder="请选择" >
            <el-option
              v-for="(item,index) in llBank"
              :key="index"
              :label="item.label"
              :value="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="银行预留手机号" prop="bankPhone">
          <div style="display: flex;">
            <el-input style="width: 250px;" v-model="dataForm.bankPhone" placeholder="请输入"></el-input>
            <div class="tip" >
              <img src="../../../assets/img/waring.svg" alt="">
              <span>请务必填写开卡时预留在银行的手机号，用于接收绑卡验证码</span>
            </div>
          </div>
      </el-form-item>
        <!-- <h3>房产信息</h3> -->
        <!-- <div class="line-box">
          <el-form-item label="居住状况" prop="liveState"  class="styW">
            <el-select class="sandh" v-model="dataForm.liveState" clearable placeholder="请选择">
              <el-option
                v-for="item in juzt"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
      
          <el-form-item label="建筑面积m²" prop="houseSize"  class="styW">
            <el-input-number class="sandh" v-model="dataForm.houseSize" :min="0"  ></el-input-number>
          </el-form-item>
          <el-form-item label="房产编号" prop="houseNo" :rules=" ishouseNo?{ required: true, message: '请输入正确房产编号', trigger: 'blur' }:{ message: '请输入正确房产编号', trigger: 'blur' }" class="styW">
            <el-input v-model="dataForm.houseNo" placeholder="请输入"></el-input>
          </el-form-item>
         
        </div> -->
        <!-- <h3>职业信息</h3> -->
        <!-- <div class="line-box">
          <el-form-item  label="工作单位" prop="campanyName"  class="sandh">
            <el-input v-model="dataForm.campanyName" placeholder="请输入"></el-input>
          </el-form-item>
     
          <el-form-item label="单位地址" prop="campanyAddress"  class="sandh">
            <el-input v-model="dataForm.campanyAddress" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="单位电话" prop="jobTitle"  class="styW">
            <el-input v-model="dataForm.jobTitle" placeholder="请输入"></el-input>
          </el-form-item>

         
     
          <el-form-item label="缴纳社医保" prop="shebaoState"  class="styW">
            <el-select class="sandh" v-model="dataForm.shebaoState" clearable placeholder="请选择">
              <el-option
                v-for="item in sb"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="每月支薪日" prop="payDay"  class="styW">
            <el-input-number class="sandh" v-model="dataForm.payDay" :min="1" :max="31" label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item label="工龄" prop="workAge"  class="styW">
            <el-input-number class="sandh" v-model="dataForm.workAge" :min="0" :max="60" label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item label="月收入" prop="income"  class="styW">
            <el-input-number class="sandh" v-model="dataForm.income" :min="0"  ></el-input-number>
          </el-form-item>

          <el-form-item label="收入来源" prop="incomeChannel"  class="styW">
            <el-select class="sandh" v-model="dataForm.incomeChannel" clearable placeholder="请选择">
              <el-option
                v-for="item in income"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div> -->
        <!-- <h3>联系人信息 （*本项必须如实填写2个非配偶紧急联系人（至少一个直系）</h3> -->
        <!-- <div class="line-box">
          <el-form-item label="姓名" prop="relationList[0].name"  :rules="{required: true,min: 2,max: 8,pattern: /^[\u4E00-\u9FA5]+$/, message: '请输入正确的姓名',trigger: 'blur'}"  class="styW">
            <el-input v-model="dataForm.relationList[0].name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="关系" prop="relationList[0].relationship" :rules="{required: true, message: '请输入正确关系',trigger: 'change'}"  class="styW">
            <el-select  class="sandh" v-model="dataForm.relationList[0].relationship" clearable placeholder="请选择">
              <el-option
                v-for="item in relationship"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系电话" prop="relationList[0].mobile" :rules="{ required: true, pattern:/^((0\d{2,3}-\d{7,8})|(1[23586794]\d{9}))$/, message: '请输入正确的电话号码', trigger: 'blur' }"  class="styW">
            <el-input v-model="dataForm.relationList[0].mobile" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注"  class="styW">
            <el-input v-model="dataForm.relationList[0].remark" placeholder="请输入"></el-input>
          </el-form-item>
        </div> -->
        <!-- <div class="line-box">
          <el-form-item label="姓名" prop="relationList[1].name" :rules="{required: true,min: 2,max: 8,pattern: /^[\u4E00-\u9FA5]+$/, message: '请输入正确的用户名',trigger: 'blur'}"  class="styW">
            <el-input v-model="dataForm.relationList[1].name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="关系" prop="relationList[1].relationship" :rules="{required: true, message: '请输入正确关系',trigger: 'change'}"  class="styW">
            <el-select class="sandh" v-model="dataForm.relationList[1].relationship" clearable placeholder="请选择">
              <el-option
                v-for="item in relationship"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系电话" prop="relationList[1].mobile" :rules="{ required: true, pattern:/^((0\d{2,3}-\d{7,8})|(1[23586794]\d{9}))$/, message: '请输入正确的电话号码', trigger: 'blur' }"  class="styW">
            <el-input v-model="dataForm.relationList[1].mobile" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="备注" class="styW">
            <el-input v-model="dataForm.relationList[1].remark" placeholder="请输入"></el-input>
          </el-form-item>
        </div> -->
      </div>
      <div v-if="dataForm.payeeType == 'ENTERPRISE'">
        <el-form-item label="对公账户银行开户名" prop="bankAcctname" class="styW">
          <el-input  @change="verification" v-model="dataForm.bankAcctname" placeholder="开户名" :disabled="isDisabled"></el-input>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="socialCreditCode" class="styW">
          <el-input @change="verification" v-model="dataForm.socialCreditCode" placeholder="统一社会信用代码" :disabled="isDisabled"></el-input>
        </el-form-item>
        <el-form-item label="收款银行账号" prop="bankCardNo" class="styW">
          <el-input type="number" v-model="dataForm.bankCardNo" placeholder="银行账号"></el-input>
        </el-form-item>
        <el-form-item class="styW" label="银行名称" prop="bankName" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
          <el-select @change="verBank" class="sandh" v-model="dataForm.bankName"  filterable  clearable placeholder="请选择" >
            <el-option
              v-for="(item,index) in llBank"
              :key="index"
              :label="item.label"
              :value="item.label"
              >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="line-box">
          <el-form-item class="styW" label="开户行所在省" prop="bankProName" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
            <el-select class="sandh" v-model="dataForm.bankProName"  filterable  clearable placeholder="请选择省" >
              <el-option
                v-for="(item,index) in shengList"
                :key="index"
                :label="item.region"
                :value="item.region">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="styW" label="所在市" prop="bankCityName" :rules="{ required: true, message: $t('validate.required'), trigger: 'change' }">
            <el-select @change="verCity" class="sandh" v-model="dataForm.bankCityName"  filterable  clearable placeholder="请选择市" >
              <el-option
                v-for="(item,index) in shiList"
                :key="index"
                :label="item.region"
                :value="item.region">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item v-if="dataForm.bankCityName && dataForm.bankName" label="开户支行名称" prop="brabankName" class="styW">
          <el-select @change="verBankName" class="sandh" v-model="dataForm.brabankName"  filterable  clearable placeholder="请选择开户支行" >
              <el-option
                v-for="(item,index) in brabankList"
                :key="index"
                :label="item.brabank_name"
                :value="item.brabank_name">
              </el-option>
            </el-select>
        </el-form-item>
      </div>
    </el-form>
    <div class="checked" v-if="payChannelId == 0">
      <el-checkbox v-model="isAuth" size="">我已阅读并同意</el-checkbox><span class="auth_con" @click="openUrl('service')">《技术服务用户协议》</span><span>、</span><span @click="openUrl('privacy')" class="auth_con">《连连服务协议+隐私协议》</span>
    </div>
    <template slot="footer">
      
      <el-button @click='qx()'>{{ $t('cancel') }}</el-button>
      <el-button v-if="type == 'modify'" type="primary" :disabled="isButton" @click="dataFormSubmitHandle1()">确定</el-button>
      <el-button v-else type="primary" :disabled="isButton" @click="dataFormSubmitHandle()">{{ payChannelId == 0 ? '确认提交并开三方账户' : '确认提交' }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Cookies from "js-cookie";
import  {arrCity} from '../../../utils/city'
import  {proCity} from '../../../utils/pro_city.js'
import { set } from 'lodash';
export default {
  created(){
    setTimeout(()=>{
      console.log(1212,this.type);
    },1000)
    this.shengList = proCity
    // proCity.forEach(item => {
    //   this.shengList.push(item.name)
      
    // })
    // 银行名称
    this.$http.get(`/sys/dict/data/list?dataType=llBank`).then(r=>{
      this.llBank = r.data.data ? r.data.data.map(item => ({value:item.dictValue,label:item.dictLabel})) : []
    })
    // 学历
    // this.$http.get(`/sys/dict/data/list?dataType=EDUCATION`).then(r=>{
    //   this.xl = r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel}))
    // })
     // 婚姻
    // this.$http.get(`/sys/dict/data/list?dataType=IS_MARRIED`).then(r=>{
    //  this.hy = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
    // })
     // 职业
     this.$http.get(`/sys/dict/data/list?dataType=PROFESSIONAL`).then(r=>{
     this.zy = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
    })
     // 居住状态
    //  this.$http.get(`/sys/dict/data/list?dataType=liveState`).then(r=>{
    //  this.juzt =  r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
    // })
     // 现任职务
    //  this.$http.get(`/sys/dict/data/list?dataType=jobTitle`).then(r=>{
    //  this.jobTitle =  r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
    // })
     // 居住类型
     this.$http.get(`/sys/dict/data/list?dataType=housetype`).then(r=>{
      this.houseType = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
    })
    // 社保
    // this.$http.get(`/sys/dict/data/list?dataType=shebaoState`).then(r=>{
    //  this.sb = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
    // })
    // 单位性质
    this.$http.get(`/sys/dict/data/list?dataType=campanyMode`).then(r=>{
     this.campany = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
    })
      // 收入来源
  //  this.$http.get(`/sys/dict/data/list?dataType=incomeChannel`).then(r=>{
  //     this.income = r.data.data ?  r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
  //   })

     // 关系
    //  this.$http.get(`/sys/dict/data/list?dataType=RELATIONSHIP`).then(r=>{
    // console.log(this.relationship)
    //   this.relationship = r.data.data ?  r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []
    // })
    // 获取渠道id
    this.$http.get(`/api/trans/channel`).then(r=>{
      console.log(121,r.data.data);
      this.payChannelId = r.data.data.channel
    })
    
  },
  data () {
    return {
      payChannelId:'',
      isChangePicture:false,
      type:null,
      cityCode:'',
      isDisabled: false,
      isAuth:false,
      shengList:[],
      shiList:[],
      frontUrl:null,
      backUrl:null,
      uploadUrl:`${window.SITE_CONFIG["apiURL"]}/api/loan/sign/upload?token=${Cookies.get("token")}`,
      isButton:false,
      relationship:[],
      myLoading:true,
      visible: false,
      llBank:[],//银行名称
      xl:[], //学历
      hy:[],//婚姻
      zy:[],//职业
      juzt:[], // 居住状态
      jobTitle:[],// 现任职务
      houseType:[],// 住房类型
      sb:[],//社保
      campany:[],//单位性质
      income:[],// 收入来源
      brabankList:[],//开户支行
      loanTypeList:[
        {value:'PERSONAGE',label:'个人'},
        {value:'ENTERPRISE',label:'企业'}
      ],
      collectList:[
        {value:'PERSONAGE',label:'本人'},
        {value:'ENTERPRISE',label:'企业'}
      ],
      oldData:{},
      dataForm: {
        validityPeriod:'',
        job_title:'',
        id: '',
        email:'',
        // relationList:[{
        //   "addr": "",
        //   "createBy": "",
        //   "createTime": "",
        //   "custId": '',
        //   "email": "",
        //   "id": '',
        //   "idNo": "",
        //   "mobile": "",
        //   "name": "",
        //   "relationship": '',
        //   "remark": "",
        //   "type": '',
        //   "updateBy": "",
        //   "updateTime": "",
        //   "version": ''
        // },
        // {
        //   "addr": "",
        //   "createBy": "",
        //   "createTime": "",
        //   "custId": '',
        //   "email": "",
        //   "id": '',
        //   "idNo": "",
        //   "mobile": "",
        //   "name": "",
        //   "relationship": '',
        //   "remark": "",
        //   "type": '',
        //   "updateBy": "",
        //   "updateTime": "",
        //   "version": ''
          
        // }],
        borrowerType:'PERSONAGE',
        payeeType:'PERSONAGE',
        // campanyAddress:'',
        // campanyName:'',
        "address": "",
        "areaCode": "",
        "bankCardNo": "",
        "bankCode": "",
        "bankName": "",
        "bankAcctname":"",
        "socialCreditCode":"",
        "bankProName":"",
        "bankCityName":"",
        "brabankName":"",
        "verifyId":"",
        "cnapsCode":"",
        "beginLive": "",
        "birthday": "",
        "campanyMode": "",
        "carStatus": "",
        "cityCode": "",
        "companyType": "",
        "createDate": "",
        "creator": "",
        "custName": "",
        // "educationCode": "",
        "email": "",
        // "houseNo": "",
        // "houseSize": "",
        "houseStatus": "",
        "houseType": "",
        "id": '',
        "idNo": "",
        "repName":"",
        "idType": "",
        // "income": "",
        // "incomeChannel": "",
        // "isMarriedCode": "",
        // "jobTitle": "",
        // "liveState": "",
        "loanInfo": '',
        "mobile": "",
        // "payDay": "",
        "provinceCode": "",
        "registerAddress": "",
        "registerAreaCode": "",
        "registerCityCode": "",
        "registerProvinceCode": "",
        "remark": "",
        "sex": "",
        // "shebaoState": "",
        "updateBy": "",
        "updateTime": "",
        "version": '',
        // "workAge": "",
        bankPhone:"",
        // children:'',
        frontUrl:null,
        backUrl:null,
       
      }
    }
  },
  computed: {
    dataRule(){
      return {
        job_title:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // 单位地址
        // campanyAddress:[
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // 子女
        // children: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // 工作单位
        // campanyName: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // 居住 起住 事件
        beginLive: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // 房产编号
        // houseNo: [
        //   // { required: true, message: this.$t('validate.required'), trigger: 'blur' },
        //   { required: true, pattern: /^(\w){5,10}$/, message: '请输入正确房产编号', trigger: 'blur' }

        // ],
        companyType: [
          { required: true, message: this.$t('validate.required'), trigger:'change'},
        ],
        // 住房面积
        // houseSize: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // 住房类型
        // houseType: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // 居住状态
        // liveState: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'change' }
        // ],
        // 单位性质
        campanyMode: [
             { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // 单位电话
        // jobTitle: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' },
        //   { required: true, pattern: /^((0\d{2,3}-\d{7,8})|(1[23456789]\d{9}))$/, message: '请输入正确的单位电话', trigger: 'blur' }
        // ],
        // 缴纳社保
        // shebaoState: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'change' }
        // ],
        // 每月支薪水日
        // payDay: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // 工龄
        // workAge: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        // 收入来源
        // incomeChannel: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'change' }
        // ],
        // 月收入
        // income: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        // ],
        custCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        validityPeriod: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // 姓名
        custName: [{required: true,message: '请输入用户名',trigger: 'blur'},
       
        ],
        // 手机号
        mobile: [
          { required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/, message: '请输入正确的电话号码', trigger: 'blur' }

        ],
        bankPhone: [
          { required: true, pattern: /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/, message: '请输入正确的电话号码', trigger: 'blur' }

        ],
        // 证件号
        idNo: [
              {
                   required: true,
                   pattern:/^(?:\d{6}(?:\d{8}(?:\d|X|x)?|((0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])\d{3}))|[A-Z0-9]{18})$/,
                   message: '请输入正确的证件号',
              
                   trigger: 'blur'
              }
        ],
        // 法人姓名
        repName: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        // 学历
        // educationCode: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'change' }
        // ],
        // 婚姻
        // isMarriedCode: [
        //   { required: true, message: this.$t('validate.required'), trigger: 'change' }
        // ],
        // 现住地址
        address: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        bankAcctname:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        brabankName:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
       
        // 银行卡号
        bankCardNo: [
        
        { required: true, message: '请输入银行卡号', trigger: 'blur', },
        { pattern: /^\d+$/, message: '银行卡号只能包含数字', trigger: 'blur' }

        ],
        socialCreditCode:[
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        // 邮箱
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
      
      }
    },
    // ishouseNo(){
    //   let status = false
    //   if(this.dataForm.liveState == '商业按揭房' || this.dataForm.liveState == '无按揭购房' || this.dataForm.liveState == '公积金按揭购房' ){
    //     status = true
    //   }
    //   return status
    //  }
  },
  watch:{
    
    'dataForm.bankProName':{
      handler(newVal,odlVal){
        console.log(111,newVal)
       
        this.$set(this.dataForm,'bankCityName','')
        proCity.forEach(item =>{
          
        if(item.region == newVal){

         this.shiList = item.regionEntitys
        }
      })
      },
      deep:true,
    },
  },
  methods: {
    openUrl(url){
      if(url == 'service'){
        window.open('https://lcappbucket.oss-cn-shanghai.aliyuncs.com/20250223/86fc5f5fb6cb40109ae527082082177e.pdf')
      }else if(url == 'privacy'){
        window.open('https://lcappbucket.oss-cn-shanghai.aliyuncs.com/20250223/fba83e68bee04c2884c17cd21ebaaca0.pdf')
      }
    },
    // 核验银行
    verBank(item){
      this.llBank.map(i=>{
        if(i.label == item){
          this.dataForm.bankCode = i.value
        }
      })
      if(this.dataForm.bankCode != '' && this.cityCode != '' && this.dataForm.bankName != ''){
        this.$http.post('/api/trans/queryNapsCode',{
          bankCode:this.dataForm.bankCode,
          cityCode:this.cityCode,
          brabankName:this.dataForm.bankName    
        }).then(({data : res})=>{
          if(res.code != 0){
            this.$message.error(res.msg);
          }
          console.log(444,res)
          this.brabankList = res.data.data.card_list
          
        })
      }
      
    },
    verCity(item){
      this.shiList.map(i=>{ 
        if(i.region == item){
          this.cityCode = i.code
        }
      })
      if(this.dataForm.bankCode != '' && this.cityCode != '' && this.dataForm.bankName != ''){
        this.$http.post('/api/trans/queryNapsCode',{
          bankCode:this.dataForm.bankCode,
          cityCode:this.cityCode,
          brabankName:this.dataForm.bankName    
        }).then(({data : res})=>{
          if(res.code != 0){
            this.$message.error(res.msg);
          }
          console.log(444,res)
          this.brabankList = res.data.data.card_list
          
        })
      }
      
    },
    verBankName(item){
      this.brabankList.map(i=>{ 
        
        if(i.brabank_name == item){
          
          this.dataForm.cnapsCode = i.cnaps_code
        }
      })
    },
    // 核验企业信息
    verification(){
      console.log(1111,this.dataForm.borrowerType,this.dataForm.payeeType,this.dataForm.custName,this.dataForm.idNo);
      
      if(this.dataForm.borrowerType == 'ENTERPRISE' && this.dataForm.custName != ''  && this.dataForm.idNo != '' && this.dataForm.repName != ''){
       
        this.$http.post('/api/loan/sign/identity-verify',{
          name:this.dataForm.custName,
          legalRepName:this.dataForm.repName,
          orgCode:this.dataForm.idNo,
          userType:"INNERCOMPANY",
        }).then(({data : res})=>{
          if(res.code != 0){
            this.$message.error(res.msg);
          }
          if(res.data){
            this.dataForm.verifyId = res.data.verifyId
          }
          
        })
      }else if(this.dataForm.borrowerType == 'PERSONAGE' && this.dataForm.payeeType == 'ENTERPRISE' && this.dataForm.bankAcctname != '' && this.dataForm.socialCreditCode != '' && this.dataForm.custName != ''){
        console.log(3333);
        this.$http.post('/api/loan/sign/identity-verify',{
          name:this.dataForm.bankAcctname,
          legalRepName:this.dataForm.custName,
          orgCode:this.dataForm.socialCreditCode,
          userType:"INNERCOMPANY",
        }).then(({data : res})=>{
          if(res.code != 0){
            this.$message.error(res.msg);
          }
          this.dataForm.verifyId = res.data.verifyId
        })
      }
      
    },
    selectCity(){
      // this.dataForm.loanApplyList[0].signPlace = this.dataForm.loanSheng+'|'+this.dataForm.loanShi
    },
    // 选择借款人
    selectLoanType(){
      console.log(333,this.dataForm.borrowerType);
      if(this.dataForm.borrowerType == 'ENTERPRISE'){
        this.dataForm.payeeType = 'ENTERPRISE'
        console.log(444,this.dataForm.payeeType);
        this.isDisabled = true
        
      }else{
        this.isDisabled = false
      }
      
    },
    inputName(){
      this.dataForm.bankAcctname = this.dataForm.custName
    },
    inputCode(){
      this.dataForm.socialCreditCode = this.dataForm.idNo
    },
    // 图片上传成功
    handleSuccessFront(res, file) {
        this.frontUrl = res.data
        this.dataForm.frontUrl = res.data
        console.log(111,res,file);
        if(res.code == 500){
          this.$message.error(res.msg);
        }
        this.isChangePicture = false
      },
    handleSuccessBack(res, file) {
        this.backUrl = res.data
        this.dataForm.backUrl = res.data
        if(res.code == 500){
          this.$message.error(res.msg);
        }
        this.isChangePicture = false
        // console.log(222,res,this.backUrl);
      },
      handleErrorFront(err,file){
        console.log(222,err,file);
      },
    beforeUploadFront(file) {
      console.log(333,file);
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt3M = file.size / 1024 / 1024 < 3;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG、PNG 或 JPEG 格式!');
      }
   
      if (!isLt3M) {
        this.$message.error('上传图片大小不能超过 3MB!');
      }

      return isJPG && isLt3M;
    },
    beforeUploadBack(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
      const isLt3M = file.size / 1024 / 1024 < 3;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG、PNG 、JPEG、BMP 格式!');
      }
   
      if (!isLt3M) {
        this.$message.error('上传图片大小不能超过 3MB!');
      }

      return isJPG && isLt3M;
    },
    // 图片删除
    handleRemoveFront(){
      this.frontUrl = null
      this.dataForm.frontUrl = null
      this.dataForm.idNo = null
      this.dataForm.custName = null
    },
    handleRemoveBack(){
      this.backUrl = null
      this.dataForm.backUrl = null
      this.dataForm.idNo = null
      this.dataForm.custName = null
    },
    // 预览
    handlePreviewFront(){

    },
    handlePreviewBack(){

    },
    // 身份证识别
    idUpload(){
      this.myLoading = true
      if(this.frontUrl == null){
        this.$message.error("请先上传身份证头像面图片");
        this.myLoading = false
      }else if(this.backUrl == null){
        this.$message.error("请上传身份证国徽面图片");
        this.myLoading = false
      }else{
        this.$http.post('/api/loan/sign/userCertificationAuth',{
        backUrl: this.backUrl,
        frontUrl:this.frontUrl
      }).then((res) => {
        this.myLoading = false
          console.log(23,res);
          if(res.data.code == 0){
            this.$message.success(res.data.message);
            this.dataForm.custName = res.data.data.name
            this.dataForm.idNo = res.data.data.idNo
            this.dataForm.validityPeriod = res.data.data.validityPeriod
            console.log(11111,this.dataForm.custName, this.dataForm.idNo);
            this.verification()
            this.isChangePicture = true
          }else{
            this.$message.error(res.data.message);
          }
        })
      }
      
    },

    qx(){
      this.myLoading = true
      this.visible = false
      this.frontUrl = null
      this.backUrl = null
      
    },
    sf(){
      this.analyzeIDCard(this.dataForm.idNo)
    },
    init () {
      this.$http.post('/loan/transfer/signMessageReturn').then(({data : res}) => {
      if(!res.data){
        this.$message.error("请在首页修改债转转让信息");
        this.$router.push("/home");
      }else{
        this.$http.get('/loan/seal/queryInfo').then(({data : res})=>{
          if(res.code !=0){
            this.$message.error("为完成自动签署债转协议，请提供贵司印章Id，详情请咨询客服");
          }else{
            this.visible = true
            this.$nextTick(() => {
              this.$refs['dataForm'].resetFields()
              if(this.dataForm.id){
                this.getInfo()
              }else{
                this.myLoading = false
              }
             })
          }
        })
        
      }
    })

    },
    // 获取信息
    getInfo () {
    
      this.$http.get(`/loan/tcustbase/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code == 0) {
        this.frontUrl = res.data.frontUrl
        this.backUrl = res.data.backUrl 
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
       this.oldData = res.data
        // if(!this.dataForm.relationList.length){
        //   this.dataForm.relationList.push(
        //     {
        //     "addr": "",
        //     "createBy": "",
        //     "createTime": "",
        //     "custId": '',
        //     "email": "",
        //     "id": '',
        //     "idNo": "",
        //     "mobile": "",
        //     "name": "",
        //     "relationship": '',
        //     "remark": "",
        //     "type": '',
        //     "updateBy": "",
        //     "updateTime": "",
        //     "version": ''
        //   },
        //   {
        //     "addr": "",
        //     "createBy": "",
        //     "createTime": "",
        //     "custId": '',
        //     "email": "",
        //     "id": '',
        //     "idNo": "",
        //     "mobile": "",
        //     "name": "",
        //     "relationship": '',
        //     "remark": "",
        //     "type": '',
        //     "updateBy": "",
        //     "updateTime": "",
        //     "version": ''
        //   }
        //   ) 
        // }
       
        this.myLoading = false
        
        }else{
          
          return this.$message.error(res.msg)
        }
      }).catch(() => {})
    
      
    },
    analyzeIDCard(IDCard){
      console.log(IDCard,'IDCard')
     //获取用户身份证号码
     var userCard = IDCard;
      //如果身份证号码为undefind则返回空
     if(!userCard){
          return false;
     }
     //获取出生年月日
    var yearBirth = userCard.substring(6,10);
    var monthBirth = userCard.substring(10,12);
    var dayBirth = userCard.substring(12,14);
    //获取当前年月日并计算年龄
    var myDate = new Date();
    var monthNow = myDate.getMonth() + 1;
    var dayNow = myDate.getDate();
    var age = myDate.getFullYear() - yearBirth;
     if(monthNow < monthBirth || (monthNow == monthBirth && dayNow < dayBirth)){
        age--;
    }
     if (age >= 18) { 
      this.$message({
        type:'success',
        message:'18'
      })
      return true;
     }
     this.$message({
        type:'error',
        message:'15'
      })
    return false;

    
  },
    // 表单提交
    dataFormSubmitHandle1: debounce(function () {
      // this.$emit('sendValue', true);
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }       
        if(this.payChannelId == 0 && !this.isAuth){
          return this.$message.error("请阅读并同意授权协议");
        }
        if(!this.dataForm.verifyId && this.dataForm.payeeType == 'ENTERPRISE'){
          this.verification()
          if(!this.dataForm.verifyId){
            return false
          }else{
            return true
          }
        }
        console.log(121212,this.isChangePicture,this.oldData.frontUrl,this.dataForm.frontUrl);
        
        
        if(this.isChangePicture == false){
          console.log(9090);
          
          if(this.oldData.frontUrl != this.dataForm.frontUrl || this.oldData.backUrl != this.dataForm.backUrl){
            console.log(90901);
            return this.$message.error("请先提交身份证图片");
          }
          
        }
       
        if(this.type == 'modify' && this.dataForm.userStatus == 'NORMAL'){
          this.$http[!this.dataForm.id ? 'post' : 'put']('/loan/tcustbase/', {
            ...this.dataForm,

          }).then(({ data: res }) => {
            if (res.code !== 0) {
              this.isButton = false
              this.frontUrl = null
              this.backUrl = null
              return this.$message.error(res.msg)
            }
            // this.$emit('openAccount',res.data)
            if(this.dataForm.frontUrl != this.oldData.frontUrl || this.dataForm.backUrl != this.oldData.backUrl ||this.dataForm.address != this.oldData.address || this.dataForm.companyType != this.oldData.companyType){
              console.log(34322);
              
              this.$http.post('api/account/modify-userinfo-individual',{
                user_id:this.dataForm.id,
                basicInfo:{
                  address:this.dataForm.address,
                  occupation:this.dataForm.companyType,
                  name:this.dataForm.custName,
                  id_no:this.dataForm.idNo,
                  id_card_expiry_date:this.dataForm.validityPeriod,
                  id_emblem:this.dataForm.backUrl,
                  id_portrait:this.dataForm.frontUrl,
                }
              }).then(({ data: res })=>{
                if(res.code != 0){
                  return this.$message.error(res.msg)
                }
                
              }).catch(()=>{})
            }

            if(this.oldData.bankPhone && this.dataForm.bankPhone != this.oldData.bankPhone && this.dataForm.mobile == this.oldData.mobile){
              // console.log(11111,this.dataForm.bankPhone,this.oldData.bankPhone);
              this.$emit('openAccount',this.dataForm,'bankPhone',this.dataForm.bankPhone)
            
            }else if(this.oldData.mobile && this.dataForm.mobile != this.oldData.mobile && this.dataForm.bankPhone == this.oldData.bankPhone){
             
              this.$emit('openAccount',this.dataForm,'mobile',this.dataForm.mobile)
            }else if(this.oldData.mobile && this.dataForm.mobile != this.oldData.mobile && this.dataForm.bankPhone != this.oldData.bankPhone){
              this.$emit('openAccount',this.dataForm,'mobileAndBank',this.dataForm.mobile,this.dataForm.bankPhone)
            }else{
              this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                // this.visible = false
                // this.isButton = false
                this.myLoading = true
                   this.$emit('refreshDataList')
                }
            })
            }
           
                this.visible = false
                this.isButton = false
          }).catch(() => {})
          
        }else if(this.type == 'modify' && this.dataForm.userStatus == 'NOT_OPENED'){
          this.$http[!this.dataForm.id ? 'post' : 'put']('/loan/tcustbase/', this.dataForm).then(({ data: res }) => {
                    if (res.code !== 0) {
                      this.isButton = false
                      this.frontUrl = null
                      this.backUrl = null
                      return this.$message.error(res.msg)
                    }
                    // this.$emit('openAccount',res.data)
          
                    this.$message({
                      message: this.$t('prompt.success'),
                      type: 'success',
                      duration: 500,
                      onClose: () => {
                        this.visible = false
                        this.isButton = false
                        this.myLoading = true
                    
                        this.$emit('refreshDataList')
                      }
                    })
                  }).catch(() => {})
        }
        
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    dataFormSubmitHandle: debounce(function () {
      // this.$emit('sendValue', true);
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        if(this.payChannelId == 0 && !this.isAuth){
          return this.$message.error("请阅读并同意授权协议");
        }
        if(!this.dataForm.verifyId && this.dataForm.payeeType == 'ENTERPRISE'){
          this.verification()
          if(!this.dataForm.verifyId){
            return false
          }else{
            return true
          }
        }
        
        
        // if(this.dataForm.payeeType =='ENTERPRISE'){
        //   this.dataForm.relationList = []
        // }
        this.$http.post('loan/tcustbase/queryByMobileAndIdNo',this.dataForm).then(({ data: res })=>{
          console.log(333,res);
            if (res.code !== 0) {
           
            return this.$message.error(res.msg)
          }else{
            if(res.data != null){
              if(!this.dataForm.id){
                this.visible = false
                this.frontUrl = null
                  this.backUrl = null
                if(res.data.isPresentCapitalSide == true){
                  this.$emit('sendValue', res.data);
                }else{
                  this.$emit('sendValue', res.data,this.dataForm);
                }
              }else{
                this.isButton = true
                this.$http.post('/api/loan/sign/identity-verify',{
                  individualName:this.dataForm.custName,
                  idNo:this.dataForm.idNo,
                  mobileNo:this.dataForm.mobile,
                  userType:"INNERUSER",
                }).then(({data : res})=>{
                 
                  if(res.code != 0){
                    
                    this.isButton = false
                    return this.$message.error(res.msg);
                  }
                  this.$http[!this.dataForm.id ? 'post' : 'put']('/loan/tcustbase/', this.dataForm).then(({ data: res }) => {
                    if (res.code !== 0) {
                      this.isButton = false
                      this.frontUrl = null
                      this.backUrl = null
                      return this.$message.error(res.msg)
                    }
                    this.$emit('openAccount',res.data)
          
                    this.$message({
                      message: this.$t('prompt.success'),
                      type: 'success',
                      duration: 500,
                      onClose: () => {
                        this.visible = false
                        this.isButton = false
                        this.myLoading = true
                    
                        this.$emit('refreshDataList')
                      }
                    })
                  }).catch(() => {})
          
                })
                
                
              }
              
              
            }else{
              this.isButton = true
              this.$http.post('/api/loan/sign/identity-verify',{
                  individualName:this.dataForm.custName,
                  idNo:this.dataForm.idNo,
                  mobileNo:this.dataForm.mobile,
                  userType:"INNERUSER",
                }).then(({data : res})=>{
                 
                  if(res.code != 0){
                    
                    this.isButton = false
                    return this.$message.error(res.msg);
                  }
                  this.$http[!this.dataForm.id ? 'post' : 'put']('/loan/tcustbase/', this.dataForm).then(({ data: res }) => {
                    if (res.code !== 0) {
                      this.isButton = false
                      this.frontUrl = null
                     this.backUrl = null
                      return this.$message.error(res.msg)
                    }
                    this.$emit('openAccount',res.data)
          
                    this.$message({
                      message: this.$t('prompt.success'),
                      type: 'success',
                      duration: 500,
                      onClose: () => {
                        this.visible = false
                        this.isButton = false
                        this.myLoading = true
                    
                        this.$emit('refreshDataList')
                      }
                    })
                  }).catch(() => {})
          
                })
             
            }
            
          }

        })
        
      })
    }, 1000, { 'leading': true, 'trailing': false })

  },
 
}
</script>

<style lang="scss" scoped>
.loan_title{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.sel{
  width: 200px;
}
.tip{
  margin: 0 0 0 20px;
  color: #f59a23;
  font-weight: bold;
  img{
    width: 16px;
    margin-right: 8px;
    position: relative;
    bottom: 2px;
  }
}
h3{
  margin: 20px ;
}
.styW{
  width: 400px;
}
.styW1{
  width: 500px;
}
.sandh{
  width: 100%;
}
.tip_upload{
  display: flex;
  align-items: center;
}
.tips{
  margin: 0 0 50px 20px;
}
.id-upload{
  display: flex;
  align-items: flex-end;
  .deleteIcon{
    font-size: 26px;
    margin: 20px;
  }
  .id-card{
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    margin: 20px 0;
    .add{
      font-weight: bold;
      font-size: 30px;
      color: #000;
    }
    .title{
      font-weight: bold;
      font-size: 24px;
      line-height: 60px;
      color: #333;
    }
  }
  .avatar{
    width: 100%;
    height: 100%;
  }
  
}
.checked{
    text-align: right;
    cursor: pointer;
    ::v-deep .el-checkbox__inner{
      border-radius: 50%;
      // width: 16px;
      // height: 16px;
    }
    .auth_con{
      color: #d9001b;
      cursor: pointer;
    }
  }
</style>
